import React, { useRef, useEffect } from "react";
import Editor from "@monaco-editor/react";

const CodeAnswerEditor = ({
    value,
    onChange,
    language = "javascript",
    height = "300px"
}) => {
    const editorRef = useRef(null);

    const handleEditorChange = (newValue) => {
        if (onChange) {
            onChange(newValue);
        }
    };

    useEffect(() => {
        const editor = editorRef.current;
        if (!editor) return;

        const handleResize = () => {
            editor.layout(); // manually adjust layout on window resize
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // console.log(language);

    const handleEditorDidMount = (editor) => {
        editorRef.current = editor;
    };

    const resolvedLanguage = typeof language === "string"
        ? ["js", "jsx"].includes(language) ? "javascript" :
            language === "ts" ? "typescript" :
                language === "py" ? "python" :
                    language.toLowerCase()
        : "plaintext";
    return (
        <div style={{ height, width: "100%" }}>
            <Editor
                height={height}
                language={resolvedLanguage}
                value={value}
                onChange={handleEditorChange}
                onMount={handleEditorDidMount}
                theme="vs-light"
                options={{
                    semanticHighlighting: true,
                    minimap: { enabled: false },
                    fontSize: 14,
                    fontFamily: 'Fira Code, monospace',
                    wordWrap: "on",
                    scrollBeyondLastLine: false,
                    lineNumbers: "on",
                    automaticLayout: true,
                    formatOnPaste: true,
                    formatOnType: true,
                    tabCompletion: "off",
                    suggestOnTriggerCharacters: false,
                    quickSuggestions: false,
                    contextmenu: false,
                }}
            />
        </div>
    );
};

export default CodeAnswerEditor;
